import { PropsWithChildren, ReactNode, createContext, createElement, useContext } from 'react';
import { DealViewModel } from '@common/model/deal';
import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';
import { MessageType } from '@common/model/dialog/message/messageType';
import { DialogViewModel } from '@common/model/dialog/dialogViewModel';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { PropsWithFalgs } from '@cp/ds';
import { MemberUser } from '@youhelp-ru/core';
import { DealMessageFlags, DealMessageSlots } from './types';

export interface DealMessageContextType extends PropsWithFalgs<DealMessageFlags> {
  isAuthor: boolean;
  isPreview: boolean;
  isProvider: boolean;
  isConsumer: boolean;
  isInitiator: boolean;
  isExternalMember: boolean;
  isCreatedFromVacancy: boolean;
  /** Заказ создал наниматель (приглашение), а не специалист (предложение) */
  isInitiatedByEmployer: boolean;

  deal: DealViewModel;
  dialog: DialogViewModel;
  currentMember: MemberUser;
  specialist: CatalogItemViewModel;
  message: DialogMessageViewModel<MessageType.DealProposition>;

  slotsRenderer: (slotKey: keyof DealMessageSlots) => ReactNode | undefined;
}

interface ContextType {
  value: DealMessageContextType;
}

const context = createContext<() => DealMessageContextType>(() => {
  throw new Error('DealMessageContextProvider not found');
});

export const DealMessageContextProvider = ({ children, value }: PropsWithChildren<ContextType>) =>
  createElement(context.Provider, { value: () => value }, children);

export const useDealMessageContext = () => {
  const getContext = useContext(context);
  return getContext();
};
